module.exports = __webpack_public_path__ + "img/symbol_8.7eac0d94.png";